<template>
  <div>
    <div style="padding-bottom:10vh;" v-if="isMobileOrTablet">
      <appHeader></appHeader>
      <div class="container-fluid account">
        <div class="row">
          <div class="col-sm-12 pr-0">
            <appAccountSidebar></appAccountSidebar>
          </div>
          <transition appear name="fade">
            <div class="px-4">
              <h4>Account information</h4>
              <div class="row">
                <div class="col-md-8 order-md-1 pr-md-4">
                  <div
                    class="row col-md-12 py-2 mb-4 border-radius bg-secondary rounded"
                  >
                    <div class="col-md-4">
                      <strong>Username</strong> {{ username }}
                    </div>
                    <div class="col-md-4">
                      <strong>Company</strong> {{ companyName }}
                    </div>
                    <div class="col-md-3">
                      <strong>Program</strong>
                      <span v-html="programNameHtml"></span>
                    </div>
                  </div>
                  <b-form v-on:submit.prevent="" class="needs-validation">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="firstName">First name</label>
                        <input
                          id="firstName"
                          v-model="currentUserFirstname"
                          class="form-control"
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Valid first name is required.
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="lastName">Last name</label>
                        <input
                          id="lastName"
                          v-model="currentUserLastname"
                          class="form-control"
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Valid last name is required.
                        </div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="username">Username</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">@</span>
                        </div>
                        <input
                          id="username"
                          :value="username"
                          class="form-control"
                          disabled
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="personalEmail">E-mail</label>
                      <input
                        id="personalEmail"
                        v-model="currentUserEmail"
                        class="form-control"
                        disabled
                        placeholder="Please ask your admin to set your account email address"
                        type="email"
                      />
                      <div class="invalid-feedback">
                        Please enter a valid email address for shipping updates.
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="daytimePhone">Daytime Phone</label>
                        <input
                          id="daytimePhone"
                          v-model="currentUserDayPhone"
                          class="form-control"
                          placeholder
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Valid daytime phone is required.
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="mobilePhone"
                          >Evening Phone
                          <span class="text-muted">(Optional)</span></label
                        >
                        <input
                          id="mobilePhone"
                          v-model="currentUserEveningPhone"
                          class="form-control"
                          placeholder
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="my-4">
                      <h5>Address</h5>
                      <div class="row">
                        <div class="col-md-6">
                          <label for="homeAddress1">Address Line 1</label>
                          <input
                            id="homeAddress1"
                            v-model="currentUserAddress1"
                            class="form-control"
                            placeholder="1234 Main St"
                            required
                            type="text"
                          />
                          <div class="invalid-feedback">
                            Please enter your shipping address.
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label for="homeAddress2"
                            >Address Line 2
                            <span class="text-muted">(Optional)</span></label
                          >
                          <input
                            id="homeAddress2"
                            v-model="currentUserAddress2"
                            class="form-control"
                            placeholder="Apartment or suite"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-5">
                        <label for="homeCity">City</label>
                        <input
                          id="homeCity"
                          v-model="currentUserCity"
                          class="form-control"
                          placeholder="Hometown"
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Please provide a valid city.
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label for="homeState">State</label>
                        <input
                          id="homeState"
                          v-model="currentUserState"
                          class="form-control"
                          placeholder="State"
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Please provide a valid state.
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label for="homeZip">Zip / Postcode</label>
                        <input
                          id="homeZip"
                          v-model="currentUserZip"
                          class="form-control"
                          placeholder
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">Zip code required.</div>
                      </div>
                    </div>
                    <button
                      class="btn btn-primary btn-lg btn-block mt-3"
                      v-on:click="updateInformation"
                    >
                      Update information
                    </button>
                  </b-form>
                </div>
                <div class="col-md-4 order-md-2 mb-4 mt-5">
                  <div class="card bg-secondary mb-3">
                    <b-form v-on:submit.prevent="" class="needs-validation">
                      <div class="card-header font-weight-bold">
                        Password
                        <b-link v-b-modal="'modal-1'" class="float-right"
                          >Password guidelines</b-link
                        >
                      </div>
                      <div class="card-body">
                        <div class="mb-2">
                          <label for="currentPassword">Current password</label>
                          <input
                            id="currentPassword"
                            v-model="currentPassword"
                            class="form-control"
                            placeholder
                            required
                            type="password"
                          />
                          <div class="invalid-feedback">
                            Not a valid password, please read the guidelines.
                          </div>
                        </div>
                        <div class="mb-2">
                          <label for="newPassword1">New password</label>
                          <input
                            id="newPassword1"
                            v-model="newPassword1"
                            class="form-control"
                            placeholder
                            required
                            type="password"
                          />
                          <div class="invalid-feedback">
                            Not a valid password, please read the guidelines.
                          </div>
                        </div>
                        <div class="mb-2">
                          <label for="newPassword2">Repeat new password</label>
                          <input
                            id="newPassword2"
                            v-model="newPassword2"
                            class="form-control"
                            placeholder
                            required
                            type="password"
                          />
                          <div class="invalid-feedback">
                            Not a valid password, please read the guidelines.
                          </div>
                        </div>
                        <button
                          class="btn btn-primary btn-lg btn-block mt-4"
                          v-on:click="setPassword"
                        >
                          Change password
                        </button>
                      </div>
                    </b-form>
                  </div>
                </div>
              </div>
              <b-modal
                v-show="showModal"
                id="modal-1"
                modal-ok="Got it!"
                ok-only
                scrollable
              >
                <template v-slot:modal-header>
                  <h5>Password guidelines</h5>
                </template>
                <p v-html="modalInfo"></p>
              </b-modal>
            </div>
          </transition>
        </div>
      </div>
      <appFooter></appFooter>
      <navigationFooter></navigationFooter>
    </div>
    <div v-else class="mt-5">
      <appHeader></appHeader>
      <div class="container-fluid account">
        <div class="row">
          <div class="col-md-3 col-sm-12 pr-0 dark-bg">
            <appAccountSidebar></appAccountSidebar>
          </div>
          <transition appear name="fade">
            <div class="col-md-9 p-4">
              <h4>Account information</h4>
              <div class="row">
                <div class="col-md-4 order-md-2 mb-4">
                  <div class="card bg-secondary mb-3">
                    <b-form v-on:submit.prevent="" class="needs-validation">
                      <div class="card-header font-weight-bold">
                        Password
                        <b-link v-b-modal="'modal-1'" class="float-right"
                          >Password guidelines</b-link
                        >
                      </div>
                      <div class="card-body">
                        <div class="mb-2">
                          <label for="currentPassword">Current password</label>
                          <input
                            id="currentPassword"
                            v-model="currentPassword"
                            class="form-control"
                            placeholder
                            required
                            type="password"
                          />
                          <div class="invalid-feedback">
                            Not a valid password, please read the guidelines.
                          </div>
                        </div>
                        <div class="mb-2">
                          <label for="newPassword1">New password</label>
                          <input
                            id="newPassword1"
                            v-model="newPassword1"
                            class="form-control"
                            placeholder
                            required
                            type="password"
                          />
                          <div class="invalid-feedback">
                            Not a valid password, please read the guidelines.
                          </div>
                        </div>
                        <div class="mb-2">
                          <label for="newPassword2">Repeat new password</label>
                          <input
                            id="newPassword2"
                            v-model="newPassword2"
                            class="form-control"
                            placeholder
                            required
                            type="password"
                          />
                          <div class="invalid-feedback">
                            Not a valid password, please read the guidelines.
                          </div>
                        </div>
                        <button
                          class="btn btn-primary btn-lg btn-block mt-4"
                          v-on:click="setPassword"
                        >
                          Change password
                        </button>
                      </div>
                    </b-form>
                  </div>
                </div>
                <div class="col-md-8 order-md-1 pr-md-4">
                  <div
                    class="row col-md-12 py-2 mb-4 border-radius bg-secondary rounded"
                  >
                    <div class="col-md-4">
                      <strong>Username</strong> {{ username }}
                    </div>
                    <div class="col-md-4">
                      <strong>Company</strong> {{ companyName }}
                    </div>
                    <div class="col-md-3">
                      <strong>Program</strong>
                      <span v-html="programNameHtml"></span>
                    </div>
                  </div>
                  <b-form v-on:submit.prevent="" class="needs-validation">
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="firstName">First name</label>
                        <input
                          id="firstName"
                          v-model="currentUserFirstname"
                          class="form-control"
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Valid first name is required.
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="lastName">Last name</label>
                        <input
                          id="lastName"
                          v-model="currentUserLastname"
                          class="form-control"
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Valid last name is required.
                        </div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="username">Username</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">@</span>
                        </div>
                        <input
                          id="username"
                          :value="username"
                          class="form-control"
                          disabled
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="personalEmail">E-mail</label>
                      <input
                        id="personalEmail"
                        v-model="currentUserEmail"
                        class="form-control"
                        disabled
                        placeholder="Please ask your admin to set your account email address"
                        type="email"
                      />
                      <div class="invalid-feedback">
                        Please enter a valid email address for shipping updates.
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label for="daytimePhone">Daytime Phone</label>
                        <input
                          id="daytimePhone"
                          v-model="currentUserDayPhone"
                          class="form-control"
                          placeholder
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Valid daytime phone is required.
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label for="mobilePhone"
                          >Evening Phone
                          <span class="text-muted">(Optional)</span></label
                        >
                        <input
                          id="mobilePhone"
                          v-model="currentUserEveningPhone"
                          class="form-control"
                          placeholder
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="my-4">
                      <h5>Address</h5>
                      <div class="row">
                        <div class="col-md-6">
                          <label for="homeAddress1">Address Line 1</label>
                          <input
                            id="homeAddress1"
                            v-model="currentUserAddress1"
                            class="form-control"
                            placeholder="1234 Main St"
                            required
                            type="text"
                          />
                          <div class="invalid-feedback">
                            Please enter your shipping address.
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label for="homeAddress2"
                            >Address Line 2
                            <span class="text-muted">(Optional)</span></label
                          >
                          <input
                            id="homeAddress2"
                            v-model="currentUserAddress2"
                            class="form-control"
                            placeholder="Apartment or suite"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-5">
                        <label for="homeCity">City</label>
                        <input
                          id="homeCity"
                          v-model="currentUserCity"
                          class="form-control"
                          placeholder="Hometown"
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Please provide a valid city.
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label for="homeState">State</label>
                        <input
                          id="homeState"
                          v-model="currentUserState"
                          class="form-control"
                          placeholder="State"
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">
                          Please provide a valid state.
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label for="homeZip">Zip / Postcode</label>
                        <input
                          id="homeZip"
                          v-model="currentUserZip"
                          class="form-control"
                          placeholder
                          required
                          type="text"
                        />
                        <div class="invalid-feedback">Zip code required.</div>
                      </div>
                    </div>
                    <button
                      class="btn btn-primary btn-lg btn-block mt-5"
                      v-on:click="updateInformation"
                    >
                      Update information
                    </button>
                  </b-form>
                </div>
              </div>
              <b-modal
                v-show="showModal"
                id="modal-1"
                modal-ok="Got it!"
                ok-only
                scrollable
              >
                <template v-slot:modal-header>
                  <h5>Password guidelines</h5>
                </template>
                <p v-html="modalInfo"></p>
              </b-modal>
            </div>
          </transition>
        </div>
      </div>
      <appFooter></appFooter>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AccountSidebar from "./AccountSidebar.vue";
import { mapState } from "vuex";
import { trim } from "core-js/internals/string-trim";
import navigationFooter from "../../components/navigationFooter.vue";
import { isMobile, isTablet } from "mobile-device-detect";

export default {
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAccountSidebar: AccountSidebar,
    navigationFooter: navigationFooter,
  },
  data() {
    return {
      showModal: true,
      modalInfo:
        "<p><strong>It should</strong></p><ul><li>Have at least 8 characters</li> <li>Be comprised of a mix of letters, numbers and special characters (punctuation marks and symbols)</li><li>Be comprised of a mix of upper and lower case characters</li></ul><p><strong>It should not</strong></p><ul><li>Be comprised of, or otherwise utilize, words that can be found in a dictionary</li><li>Be comprised of an obvious keyboard sequence (i.e., QWERTY)</li><li>Include a participant name</li><li>Contain a participants username</li><li>Be a participants current password</li></ul>",

      newUserEmail: null,
      newUserFirstname: null,
      newUserLastname: null,
      newUserAddress1: null,
      newUserAddress2: null,
      newUserCity: null,
      newUserState: null,
      newUserZip: null,
      newUserDayPhone: null,
      newUserEveningPhone: null,

      currentPassword: null,
      newPassword1: null,
      newPassword2: null,
    };
  },
  computed: {
    ...mapState({
      companyName: (state) => state.company.name,
      programNameHtml: (state) => state.company.programNameHtml,

      userId: (state) => state.user.profile.id,
      username: (state) => state.user.profile.username,
      userEmail: (state) => state.user.profile.email,
      userFirstname: (state) => state.user.profile.firstName,
      userLastname: (state) => state.user.profile.lastName,
      userAddress1: (state) => state.user.profile.address1,
      userAddress2: (state) => state.user.profile.address2,
      userCity: (state) => state.user.profile.city,
      userState: (state) => state.user.profile.state,
      userZip: (state) => state.user.profile.zip,
      userDayPhone: (state) => state.user.profile.dayPhone,
      userEveningPhone: (state) => state.user.profile.eveningPhone,
    }),
    currentUserEmail: {
      get() {
        return this.newUserEmail === null ? this.userEmail : this.newUserEmail;
      },
      set(val) {
        this.newUserEmail = val;
      },
    },
    currentUserFirstname: {
      get() {
        return this.newUserFirstname === null
          ? this.userFirstname
          : this.newUserFirstname;
      },
      set(val) {
        this.newUserFirstname = val;
      },
    },
    currentUserLastname: {
      get() {
        return this.newUserLastname === null
          ? this.userLastname
          : this.newUserLastname;
      },
      set(val) {
        this.newUserLastname = val;
      },
    },
    currentUserAddress1: {
      get() {
        return this.newUserAddress1 === null
          ? this.userAddress1
          : this.newUserAddress1;
      },
      set(val) {
        this.newUserAddress1 = val;
      },
    },
    currentUserAddress2: {
      get() {
        return this.newUserAddress2 === null
          ? this.userAddress2
          : this.newUserAddress2;
      },
      set(val) {
        this.newUserAddress2 = val;
      },
    },
    currentUserCity: {
      get() {
        return this.newUserCity === null ? this.userCity : this.newUserCity;
      },
      set(val) {
        this.newUserCity = val;
      },
    },
    currentUserState: {
      get() {
        return this.newUserState === null ? this.userState : this.newUserState;
      },
      set(val) {
        this.newUserState = val;
      },
    },
    currentUserZip: {
      get() {
        return this.newUserZip === null ? this.userZip : this.newUserZip;
      },
      set(val) {
        this.newUserZip = val;
      },
    },
    currentUserDayPhone: {
      get() {
        return this.newUserDayPhone === null
          ? this.userDayPhone
          : this.newUserDayPhone;
      },
      set(val) {
        this.newUserDayPhone = val;
      },
    },
    currentUserEveningPhone: {
      get() {
        return this.newUserEveningPhone === null
          ? this.userEveningPhone
          : this.newUserEveningPhone;
      },
      set(val) {
        this.newUserEveningPhone = val;
      },
    },
    isMobileOrTablet: function() {
      return isMobile || isTablet;
    },
  },
  methods: {
    updateInformation: function() {
      if (!this.isUserDataValid()) {
        return;
      }
      this.$store
        .dispatch("user/setProfile", {
          id: this.userId,
          firstName: this.currentUserFirstname,
          lastName: this.currentUserLastname,
          email: this.currentUserEmail,
          address1: this.currentUserAddress1,
          address2: this.currentUserAddress2,
          city: this.currentUserCity,
          zip: this.currentUserZip,
          state: this.currentUserState,
          dayPhone: this.currentUserDayPhone,
          eveningPhone: this.currentUserEveningPhone,
        })
        .then(
          () => {
            this.showSuccess("Profile updated", () => {});
          },
          (err) => {
            this.showError("Failed to update profile");
          }
        )
        .catch(() => {
          this.showError("Failed to update profile");
        });
    },
    isUserDataValid: function() {
      return (
        this.currentUserFirstname != null &&
        trim(this.currentUserFirstname).length > 0 &&
        this.currentUserLastname != null &&
        trim(this.currentUserLastname).length > 0 &&
        this.currentUserAddress1 != null &&
        trim(this.currentUserAddress1).length > 0 &&
        this.currentUserCity != null &&
        trim(this.currentUserCity).length > 0 &&
        this.currentUserZip != null &&
        trim(this.currentUserZip).length > 0 &&
        this.currentUserState != null &&
        trim(this.currentUserState).length > 0 &&
        this.currentUserDayPhone != null &&
        trim(this.currentUserDayPhone).length > 0
      );
    },
    setPassword: function() {
      // TODO better local newPassword validation
      // TODO inline feedback about validation result
      if (this.newPassword1 !== this.newPassword2) {
        this.showError("New passwords are different");
        return;
      }

      this.$store
        .dispatch("user/setPassword", {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword1,
        })
        .then(
          () => {
            this.showSuccess("Password updated", () => {});
          },
          (err) => {
            if (err.response.status === 403) {
              this.showError("Current password is wrong", () => {});
            } else {
              this.showError("Failed to update password");
            }
          }
        )
        .catch(() => {
          this.showError("Failed to update password");
        });
    },
    showSuccess: function(message, onClose) {
      this.$bvModal
        .msgBoxOk(message, {
          size: "sm",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {
          onClose();
        });
    },
    showError: function(message) {
      this.$bvModal.msgBoxOk(message, {
        size: "sm",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        okVariant: "danger",
        centered: true,
      });
    },
  },
  created() {
    this.$store.dispatch("company/fetchCompany");
    this.$store.dispatch("user/fetchProfile");
  },
};
</script>

<style lang="scss" scoped>
.card {
  .card-body {
    padding: 16px 24px;
    background-color: $gray-300;
  }
  input {
    background-color: $white;
  }
}
</style>
